import { render, staticRenderFns } from "./notSign.vue?vue&type=template&id=11bccff6&scoped=true"
import script from "./notSign.vue?vue&type=script&lang=js"
export * from "./notSign.vue?vue&type=script&lang=js"
import style0 from "./notSign.vue?vue&type=style&index=0&id=11bccff6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11bccff6",
  null
  
)

export default component.exports